exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-card[data-v-021c0336]{width:40vw;padding:5px}.box-card .text[data-v-021c0336]{font-size:14px}.box-card .item[data-v-021c0336]{margin:0 5px 5px 0}.box-card .tag-box[data-v-021c0336]{max-height:20vh;padding:5px;overflow:auto}.box-card .clearfix[data-v-021c0336]:after,.box-card .clearfix[data-v-021c0336]:before{display:table;content:\"\"}.box-card .clearfix[data-v-021c0336]:after{clear:both}.point[data-v-021c0336]{cursor:pointer}[data-v-021c0336] .el-table__header th{background-color:#f4f4f4;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-021c0336","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/dingComponents/FlowTable.vue
// module id = 6fKR
// module chunks = 7 55 92 247